"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
let RolesService = class RolesService {
    constructor(_http, _talk) {
        this._http = _http;
        this._talk = _talk;
        //initializations
        this.roleURL = "/role";
    }
    get() {
        return JSON.parse(JSON.stringify(this.roles));
    }
    getRoleById(id) {
        if (typeof id !== 'number' && id.hasOwnProperty('id')) {
            id = id.id;
        }
        let roles = JSON.parse(JSON.stringify(this.roles));
        for (let r in roles) {
            if (roles[r].id == id) {
                return roles[r];
            }
        }
        console.log('ROLE NOT FOUND: ' + id);
    }
    getRoleBySlug(slug) {
        let roles = JSON.parse(JSON.stringify(this.roles));
        for (let r in roles) {
            if (roles[r].slug == slug) {
                return roles[r];
            }
        }
        console.log('ROLE NOT FOUND');
        console.log(slug);
    }
    pull() {
        return this._http.get(this.roleURL)
            .toPromise()
            .then(response => this.roles = JSON.parse(response._body))
            .catch(this._talk.handle);
    }
};
exports.RolesService = RolesService;
exports.RolesService = RolesService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService])
], RolesService);
//# sourceMappingURL=roles.service.js.map